<template>
  <div class="main-content">
    <div class="content">
      <h2>{{ message }}</h2>
    </div>
  </div>
</template>
<script>
import { B2BStoreNamespace as storeNS } from "../store/index";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { clientId } from "../services/http-client";
export default {
  name: "B2BWelcomeComponent",
  props: {
    message: "",
  },

  data() {
    return {
      clientId: clientId,
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      user: "user",
    }),
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  position: relative;
  display: flex;
  height: calc(100vh - 200px);
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    width: 100%;
    line-height: 1.4;
    padding: 110px 40px;
    text-align: center;
    background: #fff;

    h2 {
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      color: #151515;
      padding-top: 10px;
      margin-top: 0px;
      margin-bottom: 25px;
    }
  }
}
</style>
